import { buildDirectBackendUrl, createDirectBackendHeaders } from '@/lib/direct-backend-api';

interface RawAuthorStats {
  drafts?: number;
  frozen?: number;
  progress?: number;
  completed?: number;
  abandoned?: number;
}

interface AuthorStatsResponse {
  success?: boolean;
  stats?: RawAuthorStats;
}

interface FetchAuthorStatsParams {
  accessToken: string;
}

interface NormalizedAuthorStats {
  drafts: number;
  frozen: number;
  progress: number;
  completed: number;
  abandoned: number;
  total: number;
}

export async function fetchAuthorStats({
  accessToken,
}: FetchAuthorStatsParams): Promise<NormalizedAuthorStats> {
  const response = await fetch(buildDirectBackendUrl('/api/fanfics-custom/my/stats'), {
    headers: createDirectBackendHeaders({ accessToken }),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch author stats');
  }

  const data: AuthorStatsResponse = await response.json();
  const rawStats = data.stats ?? {};
  const drafts = rawStats.drafts ?? 0;
  const frozen = rawStats.frozen ?? 0;
  const progress = rawStats.progress ?? 0;
  const rawCompleted = rawStats.completed ?? 0;
  const abandoned = rawStats.abandoned ?? 0;
  const completed = rawCompleted + abandoned;

  return {
    drafts,
    frozen,
    progress,
    completed,
    abandoned,
    total: drafts + frozen + progress + rawCompleted + abandoned,
  };
}
